// TODO migrate all filters to TS module `table-filter`

import dateRange from "./date-range";
import progress from "./progress";
import roles from "./roles";
import staticLevelFilter from "./staticLevelFilter";

export * from "./useStaticStatesFilter";
export * from "./useSchedulingStatesFilter";
export * from "./useWithoutTemplateFilter";
export * from "./progress/ProgressFilterDropdown";
export * from "./useUserStatesFilter";

export default {
  dateRange,
  roles,
  progress,
  staticLevelFilter,
};
